import Node from 'ln/node/Node';
import View from 'ln/view/View';
import Model from 'ln/model/Model';
import ListRenderer from 'ln/list/ListRenderer';
import UserCourseModel from '../models/UserCourseModel';
import CourseElementsIoC from '../CourseElementsIoC';
import { scanner } from 'ln/view/Scanner';

class CoursePreview extends View {
	
	public listRenderer:ListRenderer<Model>;
	
	constructor( public model:UserCourseModel ) {
		super( model );
		this.defaultTemplate = 'krw.usercoursepreview';
	}
	
	public init() {
		
		this.listRenderer = new ListRenderer<Model>( Node.js( 'course-elements' ) );

		// register 
		this.listRenderer.ioc = new CourseElementsIoC<Model>( this );
		
		this.node.js('expand').click.add( this.toggleExpand, this );
		
		Node.js( 'view-menu' ).click.add( this.toggleAllDays, this );

		this.renderSequences();

		scanner.scan( this.node );
		
	}
	
	private toggleExpand(){
		this.node.js('expandable').toggleClass( 'hidden' );
		this.node.js('expand-btn').toggleClass( 'rotate-180' );
	}

	renderSequences() {
		this.listRenderer.source = this.model.sequences;
	}
	
	public toggleDaybreak( n:Node ){
		this.toggleAllElements( n, n.hasClass( 'collapsed' ) );
		n.toggleClass( 'collapsed' );
	}
	
	public toggleAllElements( n:Node, show:boolean = true ){

		var native = <HTMLElement> n.native.nextSibling;

		while( native != null ) {

			var next = Node.fromNative( native );
			if( next.hasClass( 'daybreak' ) ) break;
			next.toggleClass( 'hidden', !show );

			native = <HTMLElement> native.nextSibling;
		}
	}
	
	private toggleAllDays( n:Node ){
		let daybreaks = this.node.all( '.daybreak' );
		daybreaks.forEach( ( n:Node ) => {
			if( !n.hasClass( 'collapsed' ) ) this.toggleDaybreak( n );
		});
	}
}

export default CoursePreview;